import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Container,
  Grid,
  Typography,
  TextField,
  CircularProgress,
} from "@material-ui/core";

import EmpresasService from '../../services/EmpresasServices'
import { desSeleccionarEmpresaABM, seleccionarEmpresaABM } from "../../actions/empresas/empresas";
import { LimpiarEmpresComunicacion, seleccionarEmpresComunicacion } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";

const BuscadorEmpresas = (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const cargando = open && options.length === 0;
  const [textoBuscado, setTextoBuscado] = useState("");

  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setTextoBuscado(e.target.value);
    } else {
      limpiarComponente();
    }
  };
  const handleEmpresaSeleccionada = (empresa) => {
    if (!!empresa && props.esComunicacion !== true) {
      dispatch(seleccionarEmpresaABM(empresa));
    } else if ((!!empresa && props.esComunicacion === true)) {
      dispatch(seleccionarEmpresComunicacion(empresa))
    }
    else {
      limpiarComponente();

    }
  };
  useEffect(() => {
    let active = true;

    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await EmpresasService.traerPorCUIToDenominacion(texto)
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            setOptions(
              Object.keys(lista).map((id_empresa) => lista[id_empresa])
            );
          }
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [textoBuscado]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const limpiarComponente = () => {
    dispatch(desSeleccionarEmpresaABM());
    dispatch(LimpiarEmpresComunicacion());
  };
  return (
    <>
      <Grid container spacing={3}>
        {props.titulo && (
          <Grid item xs={3}>
            <Typography
              component="h1"
              variant="h5"
              style={{
                marginLeft: 25,
                marginTop: 20,
                align: "center",
                color: "#FAFAFA",
                justifyContent: "center",
              }}
            >
              Buscar
            </Typography>

          </Grid>
        )}
        <Grid item xs={6}>
          <Container
            style={{
              padding: 3,
              marginTop: 5,
              margin: 5,
            }}
          >
            <Autocomplete
              id="buscadorEmpresas"
              style={{
                width: 400,
                padding: 6,
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
              }}
              loadingText="Buscando..."
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              onChange={(event, newValue) => {
                handleEmpresaSeleccionada(newValue);
              }}
              getOptionSelected={(option, value) =>
                option.idEmpresa === value.idEmpresa
              }
              getOptionLabel={(option) =>
                `${option.denominacion} ${option.cuit}`
              }
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={
                      (option.fechaBaja === "" || option.fechaBaja === null)
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {`${option.denominacion}`}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {" "}
                    {`CUIT: ${option.cuit}`}
                  </span>
                </div>
              )}
              options={options}
              loading={cargando}
              renderInput={(params) => (
                <TextField
                  onChange={handleInputChange}
                  style={{
                    padding: 3,
                  }}
                  {...params}
                  label="Denominación | CUIT"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cargando ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default BuscadorEmpresas;
